"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _platformOption = require("../platformOption");
var _copyText = require("@/utils/copyText");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 商品/订单列表的「商品信息」单元格：主图 + 平台角标 + 标题 + 商品ID（可复制）+ 价格。
 * 商品页与订单页共用，避免两处维护同一段展示结构。
 */
var _default = exports.default = {
  name: 'SuperSubsidyV2GoodsInfoCell',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      platformIcon: _platformOption.PLATFORM_ICON_MAP
    };
  },
  methods: {
    // 复制商品ID
    onCopy: function onCopy() {
      (0, _copyText.copyText)(this.row.goodsId);
    }
  }
};